import Box from "@mui/material/Box";
import CardContext from "components/templatesComponents/CardContext";
import Link from "components/templatesComponents/Link";
import { useGetAllSites } from "hooks/site.hook";
import PropTypes from "prop-types";
import React, { Fragment, useContext, useMemo } from "react";

const TileCard = (props) => {
  const { page: pageVersion = {}, title = "", description = "" } = props;
  const { fullPath, page } = pageVersion;
  let { contents = [] } = pageVersion;
  const { siteId } = page || {};

  if (!Array.isArray(contents)) {
    contents = [contents];
  }

  const { data: allSites = [] } = useGetAllSites();

  const findSiteById = useMemo(() => allSites?.find((site) => site.id === siteId), [allSites, siteId]);

  const { host, name: siteNameById } = findSiteById || {};

  const siteName = contents ? contents[0]?.value : "";

  const logoSite = siteName || siteNameById;

  const { Wrapper = Fragment, wrapperProps = {} } = useContext(CardContext);

  const external = useMemo(() => {
    if (typeof window !== "undefined") {
      return host !== window.location.host;
    }
    return false;
  }, [host]);
  const isBoFullPath =
    fullPath && fullPath.includes("site=") && fullPath.includes("page=") && fullPath.includes("version=");

  return (
    <Wrapper {...wrapperProps}>
      <Box className="fr-tile fr-tile--horizontal fr-enlarge-link" sx={{ height: "100%" }}>
        <div className="fr-tile__body">
          <div className="fr-tile__content">
            <h4 className="fr-tile__title">
              <Link
                url={isBoFullPath ? fullPath : `${host}${fullPath}`}
                external={external}
                sx={{ wordBreak: "break-word", "&.fr-link[target=_blank]:after": { content: "none" } }}
              >
                {title}
              </Link>
            </h4>
            <p className="fr-tile__desc">{description}</p>
          </div>
        </div>
        <div className="fr-tile__img">
          <img src={logoSite ? `/logo-${logoSite}.svg` : "/default-image.png"} className="fr-responsive-img" alt="" />
        </div>
      </Box>
    </Wrapper>
  );
};

TileCard.propTypes = {
  page: PropTypes.oneOfType([PropTypes.string, PropTypes.shape()]),
  title: PropTypes.string,
  description: PropTypes.string,
};

export default TileCard;
